export default __webpack_public_path__ + "static/exp4-8cfddb12ea98dbc72eb50d35d87df38f.webp";